export default "__VITE_ASSET__CfNlh9$H__"